import React from 'react';
import coinIcon from '../../assets/icons/coin.png';
import './GameTopStats.css';

/**
 * Compact exploration stats under PublicNav (Game / explore only).
 */
const GameTopStats = ({
  pointsLabel = '00',
  exploredLabel = '0%',
  dropsFoundLabel = '00 / 00',
  dropsCreatedLabel = '00',
}) => {
  return (
    <aside className="game-top-stats" aria-label="Exploration stats">
      <div className="game-top-stats__inner">
        <p className="game-top-stats__stat">
          <span className="game-top-stats__label">Coins</span>
          <span className="game-top-stats__value game-top-stats__value--coins">
            <img
              src={coinIcon}
              alt=""
              className="game-top-stats__coin-icon"
              width={14}
              height={14}
              draggable={false}
            />
            {pointsLabel}
          </span>
        </p>
        <p className="game-top-stats__stat">
          <span className="game-top-stats__label">Explored</span>
          <span className="game-top-stats__value">{exploredLabel}</span>
        </p>
        <p className="game-top-stats__stat">
          <span className="game-top-stats__label">Drops found</span>
          <span className="game-top-stats__value">{dropsFoundLabel}</span>
        </p>
        <p className="game-top-stats__stat">
          <span className="game-top-stats__label">Created</span>
          <span className="game-top-stats__value">{dropsCreatedLabel}</span>
        </p>
      </div>
    </aside>
  );
};

export default GameTopStats;
